import * as PIXI from 'pixi.js';
import CardContainer from './cardContainer';
import HandContainer from './handContainer';
import ActionButtonsContainer from './actionButtonsContainer';
import { RESOLUTION, APP_WIDTH, APP_HEIGHT, CARD_WIDTH, CARD_HEIGHT, getProxiedCardImageUrl, redrawFullScreenOverlay } from '../utils/commonUtils';
import AssetsLoader from '../utils/assetsLoader';

const SCALE_FACTOR = 1.3;

export default class MulliganContainer extends PIXI.Container {
    constructor(hand, goingFirst = true) {
        super();

        const mulliganOverlayGraphics = new PIXI.Graphics();
        mulliganOverlayGraphics.label = 'mulliganOverlayGraphics';
        mulliganOverlayGraphics.x = 0;
        mulliganOverlayGraphics.y = 0;
        mulliganOverlayGraphics.rect(-APP_WIDTH / 2, -APP_HEIGHT / 2, APP_WIDTH, APP_HEIGHT);
        mulliganOverlayGraphics.fill({ color: '#000000' });
        mulliganOverlayGraphics.alpha = 0.7;
        this.addChild(mulliganOverlayGraphics);

        const handContainer = new HandContainer(hand.length, hand);
        handContainer.label = 'handContainer';
        handContainer.scale.set(SCALE_FACTOR);
        handContainer.x = 0;
        handContainer.y = 0;
        this.addChild(handContainer);

        const goingFirstSprite = new PIXI.Sprite();
        goingFirstSprite.label = 'goingFirstSprite';
        goingFirstSprite.texture = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.GOING_FIRST);
        goingFirstSprite.x = 0;
        goingFirstSprite.y = -525;
        goingFirstSprite.anchor.set(0.5);
        goingFirstSprite.visible = goingFirst;
        this.addChild(goingFirstSprite);

        const goingSecondSprite = new PIXI.Sprite();
        goingSecondSprite.label = 'goingSecondSprite';
        goingSecondSprite.texture = PIXI.Assets.get(AssetsLoader.eDefaultAssetsAliases.GOING_SECOND);
        goingSecondSprite.x = 0;
        goingSecondSprite.y = -525;
        goingSecondSprite.anchor.set(0.5);
        goingSecondSprite.visible = !goingFirst;
        this.addChild(goingSecondSprite);

        const title = new PIXI.Text({
            text: 'Keep Your Cards?',
            style: {
                fontFamily: 'Arial',
                fontSize: 60,
                fill: '#ffffff',
            }
        });
        title.label = 'title';
        title.anchor.set(0.5, 1);
        title.x = 0;
        title.y = -350;
        this.addChild(title);

        const actionButtonsContainer = new ActionButtonsContainer();
        actionButtonsContainer.label = 'actionButtonsContainer';
        actionButtonsContainer.x = 0;
        actionButtonsContainer.y = 300;
        actionButtonsContainer.update({ clientGameState: { availableActions: ['KEEP_HAND', 'REPLACE_HAND'] } });
        this.addChild(actionButtonsContainer);

        const waitingForOtherPlayerText = new PIXI.Text({
            text: 'Waiting for other player to decide...',
            style: {
                fontFamily: 'Arial',
                fontSize: 45,
                fill: '#ffffff',
            }
        });
        waitingForOtherPlayerText.visible = false;
        waitingForOtherPlayerText.label = 'waitingForOtherPlayerText';
        waitingForOtherPlayerText.anchor.set(0.5, 0);
        waitingForOtherPlayerText.x = 0;
        waitingForOtherPlayerText.y = 300;
        this.addChild(waitingForOtherPlayerText);
    }

    update(gameState) {
        const handContainer = this.getChildByLabel('handContainer');
        handContainer.updateHand(gameState, gameState.player);

        if (gameState.clientGameState.decisionMade) {
            const actionButtonsContainer = this.getChildByLabel('actionButtonsContainer');
            actionButtonsContainer.visible = false;
            const waitingForOtherPlayerText = this.getChildByLabel('waitingForOtherPlayerText');
            waitingForOtherPlayerText.visible = true;
        }
    }

    resize(width, height) {
        redrawFullScreenOverlay(this.getChildByLabel('mulliganOverlayGraphics'), width, height);
    }
}